import Vue from 'vue'
import router from '@/router'
import Swal from 'sweetalert2'
import { formatApiError } from '@/libs/api-error'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
   baseURL: process.env.VUE_APP_SERVICE_URL,
  // timeout: 1000,
   headers: {'Authorization': 'Bearer '+localStorage.getItem('accessToken')}
})
let self = this;
// Add a response interceptor
axiosIns.interceptors.response.use( (response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response dat
  return response;
},  (error) =>  {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  
  // 統一把後端訊息轉成用戶看得懂的中文，避免把驗證錯誤的 JSON 原文丟給用戶
  if (error.response && error.response.data && typeof error.response.data === 'object') {
    error.response.data.message = formatApiError(error)
  }

  if(error.response.status == 401 || error.response.status == 429){

    console.log('error.response.status',error.response.status)
    localStorage.clear();
    
    // 检查当前路由是否已经是登录页面
    if (router.currentRoute.path !== '/login') {
      router.replace('/login').then(() => {
        let message = error.response.status === 401
          ? "你已被登出！" 
          : "你已被登出！檢測用戶正在被攻擊，系統限制請求一小時！";
        
        Swal.fire({
          text: message,
          confirmButtonText: "確定",
          icon: "error",
          timer: 5000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
          showClass: {
            popup: "animate__animated animate__bounceIn",
          },
          buttonsStyling: false,
        });
      });
    }
  }
  
  return Promise.reject(error);
});

Vue.prototype.$http = axiosIns

export default axiosIns